import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import './assets/tailwind.css'

import EasySlider from 'vue-easy-slider'
Vue.use(EasySlider)

const moment = require('moment')
require('moment/locale/fi')

Vue.use(require('vue-moment'), {
    moment
})

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
